/**
 * Attaches prefixes or suffices to strings
 * @param {string[]|string} strings Strings to attach to
 * @param {{}} options Attachment options
 * @param {string} [options.prefix] Prefix to attach
 * @param {string} [options.suffix] Suffix to attach
 * @param {boolean} [options.inclusive] Includes given strings in output (default: true)
 * @returns {string[]}
 */
export default function attachToStrings(strings, options = {}) {
  strings = [].concat(strings || []);
  const inclusive = options && 'inclusive' in options
    ? options.inclusive : true;
  let result = inclusive ? strings : [];
  const prefix = [].concat(options.prefix || []);
  const suffix = [].concat(options.suffix || []);
  const attachCount = Math.max(prefix.length, suffix.length);
  for (let i = 0; i < attachCount; ++i) {
    result.push(
      ...strings.map(string => {
        return (i < prefix.length ? prefix[i] : '' ) + string
          + (i < suffix.length ? suffix[i] : '' );
      })
    );
  }
  return result;
}
